import PropTypes from 'prop-types'
import {useLayoutEffect, useState, Fragment, useEffect} from 'react';
import BtnActionLink from '../action-bts/Btn-action-basic';
import {lazy, Suspense} from 'react'
import ModalForm from './ModalForm'
import {connect} from 'react-redux'
import updateGlobals from '../reducer-actions/updateGlobals'
//Tracking
import updateJourney from '../reducer-actions/updateJourney'

const BookOrCall = lazy(() => import('../form/BookOrCall'));
const HeaderHelpTooltip = lazy(() => import('./header/HeaderTooltip')); 
function Header(props){
    const [screenWidth, setSW] = useState(window.innerWidth);
    const [showModal, setModal] = useState(false);

    useEffect(()=>{
        setModal(props.showBookingModal)
        if(props.showBookingModal === true){
            props.updateJourney?.("#BookMeeting")
        }
    },[props.showBookingModal])

    function toggleModal(value = -1){
        setModal(!showModal)
        props.setModal(!showModal)
    }

    useLayoutEffect(() => {
        function updateSize() {
            setSW(window.innerWidth);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
      },[]);

    return(
        <Fragment>
        {showModal &&
        <ModalForm
          closeAction={toggleModal}
        >
            <Suspense fallback={<span>Loading...</span>}>
                <BookOrCall
                  continueAction={()=>{window.dataLayer?.push?.({"event":"successful-HACMeeting-submission"});toggleModal()}}
                />
            </Suspense>
        </ModalForm>}
        <div className="container-fluid w-100 header-container">
            <div id="header" className="row">
                <div className="header-col logo col-xs-12 col-md-4"><a href="https://www.comsavings.com" target="_blank"><img src={props.logo} alt={props.logo.substring(props.logo.lastIndexOf('/')+1)}/></a></div>
                <div className={`header-col title col-xs-12 col-md-4 ${!props.subtitle ? 'center-h1' : ''}`}><span className="title-subtitle"><h1>{props.title}{screenWidth < 992 && props.bookMeeting && <Suspense fallback={<span>.</span>}><HeaderHelpTooltip onAction={()=>setModal(!showModal)}/></Suspense>}</h1>{props.subtitle && <h2>{props.subtitle}</h2>}</span></div>
                {props.bookMeeting && <div className="header-col sideaction d-none-flex d-md-block col-md-4">
                     <p>Need help?</p>
                     <BtnActionLink
                    type="secondary"
                    href="#"
                    text="Book a meeting"
                    action={toggleModal}
                    />
                </div>}
            </div>
        </div>
        </Fragment>
    )
}


Header.propTypes = {
    logo: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string
}

function mapStateToProps({global}){
    return{
        ...global
    }
}
function mapDispatchToProps(dispatch){
    return({
        'setModal': (value) => {dispatch(updateGlobals("modal",value))},
        'updateJourney': (value) => {dispatch(updateJourney(value))}
    })
}

export default connect(mapStateToProps,mapDispatchToProps)(Header);